module.exports = __webpack_public_path__ + "img/mountain.e9671c06.svg";